export default "__VITE_ASSET__CU0HyKX5__"